module.exports = __webpack_public_path__ + "static/img/produto_p.7c475e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/laranja/produto_p.png
// module id = XfuF
// module chunks = 0